export const DemographicRegions = {
  Native: 'Native',
  US: 'US',
  CA: 'CA',
} as const;

export type DemographicRegion = typeof DemographicRegions[keyof typeof DemographicRegions];

export const DEFAULT_DEMOGRAPHIC_REGION: DemographicRegion = DemographicRegions.US;

export const DemographicsDataProviders = {
  AGS: 'ags',
} as const;

export type DemographicsDataProvider = typeof DemographicsDataProviders[keyof typeof DemographicsDataProviders];

export const DEMOGRAPHIC_REGIONS_FOR_PREMIUM_DATA = [
  DemographicRegions.US,
  DemographicRegions.CA,
] as const satisfies ReadonlyArray<DemographicRegion>;
